import { RangeMonthType } from './range-month-type.enum';

export class ReportFilter {
  //id: string;
  //name: string;
  rangeValue: Date[];
  reportPeriod: RangeMonthType;
}


export interface ISettingsFilter {
  countryId?: number;
  countryCode?: string;
  vType?: string;
  term?: number;
  distance?: number;
}

export class SettingsFilter implements ISettingsFilter  {
  constructor(
    public countryId: number,
    public countryCode: string,
    public vType: string,
    public term: number,
    public distance: number,
  ) {

  }

  public static empty() {
    return new SettingsFilter(null, null, null, null, null);
  }
}


export interface IFilterBaseModel {
  countryIds?: number[];
  vTypes?: number[];
}

export class FilterBaseModel implements IFilterBaseModel {
  constructor(
    public countryIds: number[],
    public vTypes: number[],
  ) {

  }

  public static empty() {
    return new FilterBaseModel([], []);
  }
}
